<template>
    <div class="elec_station_container">
        <div class="elec_one" style="margin-bottom: 2%;">
            <div class="elec_title">电站情况</div>
            <div class="one_inner">
                <div class="one_inner_cnt">
                    <div class="one_inner_item">
                        <img src="../../../assets/image/custom/elec_inner_pic1.png" />
                        <div class="one_inner_item_data">
                            <div>{{ $t('storageOverview.dianzhanqingkuang_1') }}</div>
                            <div><i>460</i>&nbsp;WMh</div>
                        </div>
                    </div>
                    <div class="one_inner_item">
                        <img src="../../../assets/image/custom/elec_inner_pic2.png" />
                        <div class="one_inner_item_data">
                            <div>{{ $t('storageOverview.dianzhanqingkuang_2') }}</div>
                            <div><i>200</i>&nbsp;kw</div>
                        </div>
                    </div>
                    <div class="one_inner_item">
                        <img src="../../../assets/image/custom/elec_inner_pic3.png" />
                        <div class="one_inner_item_data">
                            <div>{{ $t('storageOverview.dianzhanqingkuang_3') }}</div>
                            <div><i>{{dianzhanqingkuangData && dianzhanqingkuangData.fd_val}}</i>&nbsp;{{ out_energy_unit }}</div>
                        </div>
                    </div>
                    <div class="one_inner_item">
                        <img src="../../../assets/image/custom/elec_inner_pic4.png" />
                        <div class="one_inner_item_data">
                            <div>{{ $t('storageOverview.dianzhanqingkuang_4') }}</div>
                            <div><i>2</i></div>
                        </div>
                    </div>
                    <div class="one_inner_item">
                        <img src="../../../assets/image/custom/elec_inner_pic5.png" />
                        <div class="one_inner_item_data">
                            <div>{{ $t('storageOverview.dianzhanqingkuang_5') }}</div>
                            <div><i>{{ overviewData && overviewData.rt_power }}</i>&nbsp;kw</div>
                        </div>
                    </div>
                    <div class="one_inner_item">
                        <img src="../../../assets/image/custom/elec_inner_pic6.png" />
                        <div class="one_inner_item_data">
                            <div>{{ $t('storageOverview.dianzhanqingkuang_6') }}</div>
                            <div><i>{{dianzhanqingkuangData && dianzhanqingkuangData.cd_val}}</i>&nbsp;{{ input_energy_unit }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="elec_two" style="margin-bottom: 2%;">
            <div class="elec_title" style="left: 6% !important;">充放电量统计</div>
            <div class="battery_right_btn">
                    <div :class="[pscType == 3 ? 'change_item change_item_s' : 'change_item change_item_us']" @click="changePSC(3)">{{ $t('storageOverview.day') }}</div>
                    <div :class="[pscType == 2 ? 'change_item change_item_s' : 'change_item change_item_us']" @click="changePSC(2)">{{ $t('storageOverview.month') }}</div>
                    <div :class="[pscType == 1 ? 'change_item change_item_s' : 'change_item change_item_us']" @click="changePSC(1)">{{ $t('storageOverview.year') }}</div>
                </div>
            <div class="two_inner">
                <v-chart :auto-resize="true" :options="centerBar" ref="centerBar" theme="ovilia-green" />
            </div>
        </div>
        <div class="elec_three">
            <div class="elec_title">{{ $t('storageOverview.chunengshouyi') }}</div>
            <div class="three_inner">
                <v-chart :auto-resize="true" :options="leftBar" ref="leftBar" theme="ovilia-green" />
            </div>
        </div>
        <div class="elec_one">
            <div class="elec_title">储能系统概况</div>
            <div class="four_inner">
                <el-carousel :autoplay="false" arrow="never">
                    <el-carousel-item v-for="item in page_num" :key="item">
                        <el-scrollbar style="height: 90%">
                            <div class="four_table">
                                <div class="four_table_inner" v-for="(data, index) in chunenglist[item - 1]" :key="index">
                                    <div class="left">{{data.name}}</div>
                                    <div class="right">{{data.data}}&nbsp;{{data.unit}}</div>
                                </div>
                            </div>
                        </el-scrollbar>
                    </el-carousel-item>
                </el-carousel>
            </div>
        </div>
        <div class="elec_one">
            <div class="elec_title">{{ $t('storageOverview.dianchiqingkuang') }}</div>
            <div class="five_inner">
                <div class="five_inner_left">
                    <img src="../../../assets/image/custom/elec_dianchi.png" />
                </div>
                <div class="five_inner_right">
                    <img src="../../../assets/image/custom/elec_dianchi_info.png" />
                    <!-- <div class="five_data" style="top: 29%">20%</div> -->
                    <div class="five_data" style="top: 45%">{{socData.soc}}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import "echarts/lib/chart/bar";
import "echarts/lib/chart/line";
import "echarts/lib/chart/pie";
import "echarts/lib/component/title";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/markPoint";
import 'echarts/lib/component/legendScroll';
import * as api from "@/http/api.js";
import { getDataAll } from "@/http/http-60.js";
import unitUtils from "@/utils/unit-exchange.js";
export default {
    data() {
        return {
            pscType: 1,
            overviewData: {},
            dianzhanqingkuangData: {fd_val: '', cd_val: ''},
            cfdData: {
                time_list: [],
                cd_list: [],
                fd_list: [],
            },
            shouyiBar: {
                time_list: [],
                val_list: []
            },
            page_num: 1,
            chunenglist: [],
            socData: {soc: ''},
            timer: null,
            point_ids: [],
        };
    },
    async created() {
        this.getTotalVal();
        this.getEnergyIncome();
        this.changePSC(3);
        this.getPointListByPointClassId();
        this.getBatterySoc();
        this.getRTPower();
        this.setTimer();
    },
    methods: {
        setTimer() {
            if (this.timer) {
                clearInterval(this.timer);
            }
            this.timer = setInterval(() => {
                this.getPointListByPointClassId();
            }, 60000);
        },
        getBatterySoc() {
            api.getBatterySoc().then(res => {
                if (res && res.error_code == 0) {
                    this.socData = res.bus_json;
                }
            });
        },
        async getPointListByPointClassId() {
            this.chunenglist = [];
             await api.getPointListByPointClassId({point_class_id:'020'}).then(res => {
                if (res && res.error_code == 0) {
                    const list = res.bus_json.filter(item => item.collector_id != null);
                    this.page_num = list.length;
                    this.point_ids = [];
                    list.forEach(item => {
                        this.point_ids.push(item.point_id)
                    })
                    this.getDataAll(this.point_ids);
                }
            });
        },
        getRTPower() {
            getDataAll(['1730141588107239424']).then(res => {
                let valueJson = res.bus_json;
                const realData = valueJson['1730141588107239424'];
                this.overviewData['rt_power'] = realData.p;
            });
        },
        async getDataAll(point_ids) {
            await getDataAll(point_ids).then(res => {
                let valueJson = res.bus_json;
                this.point_ids.forEach(point_id => {
                    const realData = valueJson[point_id];
                    let temp = JSON.parse(JSON.stringify(this.chunengData));
                    temp.forEach(item => {
                        if(item.key == 'xf_tcqygzm' || item.key == 'xf_tcqegzm') {
                            if(realData[item.key] == 0) item.data = this.$t('storageOverview.tanceqi_guzhang0');
                            else if(realData[item.key] == 1) item.data = this.$t('storageOverview.tanceqi_guzhang1');
                            else if(realData[item.key] == 2) item.data = this.$t('storageOverview.tanceqi_guzhang2');
                            else if(realData[item.key] == 3) item.data = this.$t('storageOverview.tanceqi_guzhang3');
                        } else if(item.key == 'cng_gz') {
                            if(realData[item.key] == 0) item.data = this.$t('storageOverview.chuanganqi_tongxin_guzhang0');
                            else if(realData[item.key] == 1) item.data = this.$t('storageOverview.chuanganqi_tongxin_guzhang1');
                        } else {
                            item.data = realData[item.key];
                        }
                    })
                    this.chunenglist.push(temp);
                })
            });
        },
        changePSC(type) {
            this.pscType = type;
            this.getYMDVal();
        },
        getYMDVal() {
            api.getYMDVal({type: this.pscType}).then(res => {
                if (res && res.error_code == 0) {
                    this.cfdData.time_list = res.bus_json.time_list;
                    this.cfdData.cd_list = res.bus_json.cd_list;
                    this.cfdData.fd_list = res.bus_json.fd_list;
                }
            });
        },
        getTotalVal() {
            api.getTotalVal({type: 3}).then(res => {
                if (res && res.error_code == 0) {
                    this.dianzhanqingkuangData = res.bus_json;
                    this.input_energy_unit = unitUtils.exchangeUnitKWH(this.dianzhanqingkuangData.cd_val).unit;
                    this.out_energy_unit = unitUtils.exchangeUnitKWH(this.dianzhanqingkuangData.fd_val).unit;
                    this.dianzhanqingkuangData.cd_val = unitUtils.exchangeUnitKWH(this.dianzhanqingkuangData.cd_val).num;
                    this.dianzhanqingkuangData.fd_val = unitUtils.exchangeUnitKWH(this.dianzhanqingkuangData.fd_val).num;
                }
            });
        },
        getEnergyIncome() {
            api.getEnergyIncome().then(res => {
                if (res && res.error_code == 0) {
                    this.shouyiBar.time_list = res.bus_json.time_list;
                    this.shouyiBar.val_list = res.bus_json.val_list;
                }
            });
        },
    },
    computed: {
        language() {
            return this.$store.state.language.language;
        },
        chunengData() {
            return [
                {
                    key: 'kt_snhfwd',
                    name: this.$t('storageOverview.kt_snhfwd'),
                    data: '',
                    unit: '℃'
                },
                {
                    key: 'kt_snhfsd',
                    name: this.$t('storageOverview.kt_snhfsd'),
                    data: '',
                    unit: '%'
                },
                {
                    key: 'kt_hjwd',
                    name: this.$t('storageOverview.kt_hjwd'),
                    data: '',
                    unit: '℃'
                },
                {
                    key: 'kt_zfwd',
                    name: this.$t('storageOverview.kt_zfwd'),
                    data: '',
                    unit: '℃'
                },
                {
                    key: 'kt_jssc',
                    name: this.$t('storageOverview.kt_jssc'),
                    data: '',
                    unit: '℃'
                },
                {
                    key: 'xf_tcqywdy',
                    name: this.$t('storageOverview.xf_tcqywdy'),
                    data: '',
                    unit: '℃'
                },
                {
                    key: 'xf_tcqycond',
                    name: this.$t('storageOverview.xf_tcqycond'),
                    data: '',
                    unit: ''
                },
                {
                    key: 'xf_tcqyqtnd',
                    name: this.$t('storageOverview.xf_tcqyqtnd'),
                    data: '',
                    unit: ''
                },
                {
                    key: 'xf_tcqyhqyjjb',
                    name: this.$t('storageOverview.xf_tcqyhqyjjb'),
                    data: '',
                    unit: ''
                },
                {
                    key: 'xf_tcqewdy',
                    name: this.$t('storageOverview.xf_tcqewdy'),
                    data: '',
                    unit: '℃'
                },
                {
                    key: 'xf_tcqecond',
                    name: this.$t('storageOverview.xf_tcqecond'),
                    data: '',
                    unit: ''
                },
                {
                    key: 'xf_tcqeqtnd',
                    name: this.$t('storageOverview.xf_tcqeqtnd'),
                    data: '',
                    unit: ''
                },
                {
                    key: 'xf_tcqehqyjjb',
                    name: this.$t('storageOverview.xf_tcqehqyjjb'),
                    data: '',
                    unit: ''
                },
                {
                    key: 'xf_tcqywde',
                    name: this.$t('storageOverview.xf_tcqywde'),
                    data: '',
                    unit: ''
                },
                {
                    key: 'xf_tcqygzm',
                    name: this.$t('storageOverview.xf_tcqygzm'),
                    data: '',
                    unit: ''
                },
                {
                    key: 'xf_tcqewde',
                    name: this.$t('storageOverview.xf_tcqewde'),
                    data: '',
                    unit: ''
                },
                {
                    key: 'xf_tcqegzm',
                    name: this.$t('storageOverview.xf_tcqegzm'),
                    data: '',
                    unit: ''
                },
                {
                    key: 'cng_wd',
                    name: this.$t('storageOverview.cng_wd'),
                    data: '',
                    unit: ''
                },
                {
                    key: 'cng_sd',
                    name: this.$t('storageOverview.cng_sd'),
                    data: '',
                    unit: ''
                },
                {
                    key: 'cng_gz',
                    name: this.$t('storageOverview.cng_gz'),
                    data: '',
                    unit: ''
                }
            ]
        },
        leftBar() {
            const option = {
                grid: {
                    left: "1%",
                    right: "3%",
                    bottom: "1%",
                    top: "15%",
                    containLabel: true
                },
                color: ["#1593CE", "#CE720b"],
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow"
                    }
                },
                xAxis: [
                    {
                        type: "category",
                        axisTick: { show: false },
                        data: this.shouyiBar.time_list,
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#999999"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        name: '单位:元',
                        type: "value",
                        // min:0,  //取0为最小刻度
                        // max: 90,
                        nameTextStyle: {
                            color: "#999999",
                            fontSize: 10
                        },
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#999999"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        },
                        splitLine: {
                            show: false,
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        },
                        splitArea: {
                            show: true,
                            areaStyle: {
                                color: ['rgba(12, 77, 135, 0.2)','rgba(0, 14, 31, 0.1)']
                            }
                        },
                    }
                ],
                series: [
                    {
                        name: '收益',
                        type: "bar",
                        barWidth: 14,
                        barGap: 0.5,
                        data: this.shouyiBar.val_list,
                        itemStyle: {
                            normal: {
                                label: {
                                    show: true,
                                    position: 'top',
                                    textStyle: {
                                        color: 'white',
                                        fontSize: 10,
                                    }
                                },
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: 'rgba(33, 178, 251, 1)'
                                }, {
                                    offset: 1,
                                    color: 'rgba(24, 47, 76, 1)'
                                }]),
                              //  barBorderRadius: [10, 10, 0, 0]
                            }
                        },
                    },
                ]
            };
            return option;
        },
        centerBar() {
            const option = {
                grid: {
                    left: "1%",
                    right: "3%",
                    bottom: "1%",
                    top: "15%",
                    containLabel: true
                },
                color: ["#1593CE", "#CE720b"],
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow"
                    }
                },
                legend: {
                    orient: "horizontal",
                    itemHeight: 12,
                    itemWidth: 12,
                    data: [
                        {
                            name: this.$t('storageOverview.fangdianliang'),
                            textStyle: {
                                color: "#fff",
                                fontSize: 12
                            }
                        },
                        {
                            name: this.$t('storageOverview.chongdianliang'),
                            textStyle: {
                                color: "#fff",
                                fontSize: 12
                            }
                        }
                    ]
                },
                xAxis: [
                    {
                        type: "category",
                        axisTick: { show: false },
                        data: this.cfdData.time_list,
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#999999"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        name: 'kWh',
                        type: "value",
                        // min:0,  //取0为最小刻度
                        // max: 90,
                        nameTextStyle: {
                            color: "#999999",
                            fontSize: 10
                        },
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#999999"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        },
                        splitLine: {
                            show: false,
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        },
                        splitArea: {
                            show: true,
                            areaStyle: {
                                color: ['rgba(12, 77, 135, 0.2)','rgba(0, 14, 31, 0.1)']
                            }
                        },
                    }
                ],
                series: [
                    {
                        name: this.$t('storageOverview.fangdianliang'),
                        type: "bar",
                        barWidth: 14,
                        barGap: 0.5,
                        data: this.cfdData.fd_list,
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: 'rgba(33, 178, 251, 1)'
                                }, {
                                    offset: 1,
                                    color: 'rgba(24, 47, 76, 1)'
                                }]),
                              //  barBorderRadius: [10, 10, 0, 0]
                            }
                        },
                    },
                    {
                        name: this.$t('storageOverview.chongdianliang'),
                        type: "bar",
                        barWidth: 14,
                        barGap: 0.5,
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: 'rgba(231, 124, 79, 1)'
                                }, {
                                    offset: 1,
                                    color: 'rgba(107, 63, 49, 1)'
                                }]),
                              //  barBorderRadius: [10, 10, 0, 0]
                            }
                        },
                        data: this.cfdData.cd_list
                    },
                ]
            };
            return option;
        },
    },
    destroyed() {
        clearInterval(this.timer);
    }
};
</script>
<style lang="scss">
.elec_station_container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    padding: 0 2rem 2rem 2rem;
    box-sizing: border-box;
    position: relative;
    color: #fff;
    .el-carousel {
        height: 100%;
        .el-carousel__container {
            height: 100%;
        }
    }
    .elec_title {
        position: absolute;
        top: 2.4%;
        left: 12%;
        color: rgba(148, 194, 232, 1);
        font-size: 0.8rem;
    }
    .elec_one {
        width: 32%;
        height: 49%;
        background: url("../../../assets/image/custom/with_border.png") no-repeat;
        background-size: 100% 100%;
        position: relative;
        .one_inner {
           // border: 1px solid red;
            position: absolute;
            top: 25%;
            left: 5%;
            width: 90%;
            height: 60%;
            .one_inner_cnt {
                display: inline-flex;
                flex-flow: row wrap;
                align-items: center;
                justify-content: space-between;
                width: 100%;
                height: 100%;
                .one_inner_item {
                    width: 30%;
                    height: 30%;
                    //border: 1px solid blue;
                    display: inline-flex;
                    align-items: center;
                    img {
                        width: 3rem;
                        height: 3rem;
                    }
                    .one_inner_item_data {
                        flex: 1;
                        height: 100%;
                        text-align: left;
                        font-size: 0.75rem;
                        display: inline-flex;
                        flex-flow: column;
                        align-items: center;
                        justify-content: space-evenly;
                        color: rgba(204, 227, 255, 1);
                        div:nth-child(2) {
                            font-size: 0.6rem;
                        }
                        i {
                            color: #fff;
                            font-size: 1rem;
                            font-weight: 600;
                        }
                    }
                }
            }
        }
        .four_inner {
          //  border: 1px solid red;
            position: absolute;
            top: 12%;
            left: 2%;
            width: 96%;
            height: 86%;
            // display: inline-flex;
            // flex-flow: row wrap;
            // align-items: center;
            .four_table {
                width: 90%;
                margin-left: 5%;
                height: 90%;
                display: inline-flex; 
                flex-flow: row wrap;
                .four_table_inner {
                    //border: 1px solid blue;
                    width: 50%;
                    min-height: 2rem;
                  //  height: 2rem;
                    text-align: center;
                   // line-height: 2rem;
                    font-size: 0.9rem;
                    border-bottom: 1px dotted rgba(24, 47, 76, 1);
                    display: inline-flex;
                    align-items: center;
                    .left {
                        width: 65%;
                        color: rgba(204, 227, 255, 1);
                        text-align: left;
                        font-size: 0.7rem;
                    }
                    .right {
                        flex: 1;
                        color: rgba(255, 255, 255, 1);
                        text-align: left;
                        font-size: 0.75rem;
                    }
                    // &:nth-child(4n + 1) {
                    //     background-color: red;
                    // }
                    &:nth-child(2n + 1) {
                        color: rgba(148, 194, 232, 1);
                    }
                }
            }
        }
        .five_inner {
           // border: 1px solid red;
            position: absolute;
            top: 25%;
            left: 15%;
            width: 70%;
            height: 60%;
            display: inline-flex;
            flex-flow: row;
            align-items: center;
            .five_inner_left {
                //width: 35%;
                height: 100%;
                display: inline-flex;
                align-items: center;
                img {
                    width: 7rem;
                }
            }
            .five_inner_right {
                flex: 1;
                height: 100%;
                display: inline-flex;
                align-items: center;
                position: relative;
                img {
                    width: 17rem;
                }
                .five_data {
                    position: absolute;
                    top: 29%;
                    left: 77%;
                    font-size: 1.2rem;
                }
            }
        }
    }
    .elec_two {
        width: 66%;
        height: 49%;
        background: url("../../../assets/image/custom/without_border.png") no-repeat;
        background-size: 100% 100%;
        position: relative;
        .battery_right_btn {
            position: absolute;
            top: 2%;
            right: 0;
            width: 80%;
            // margin-left: 20%;
            //height: 3rem;
            // border: 1px solid red;
            display: inline-flex;
            align-items: center;
            justify-content: flex-end;
            .change_item {
                width: 3rem;
                height: 1.2rem;
                line-height: 1.2rem;
                font-size: 0.7rem;
                text-align: center;
                cursor: pointer;
            }
            .change_item_s {
                color: rgba(19, 125, 254, 1);
                border: 1px solid rgba(19, 125, 254, 1);
                // background-color: rgba(148, 194, 232, 1);
                border-radius: 5px;
            }
            .change_item_us {
                color: #F3F3F3;
                border: none;//1px solid #F3F3F3;
            }
        }
        .two_inner {
            position: absolute;
            top: 12%;
            left: 0;
            width: 100%;
            height: 88%;
            .echarts {
                width: 100%;
                height: 100%;
            }
        }
    }
    .elec_three {
        width: 32%;
        height: 49%;
        background: url("../../../assets/image/custom/without_border_short.png") no-repeat;
        background-size: 100% 100%;
        position: relative;
        .three_inner {
            position: absolute;
            top: 12%;
            left: 0;
            width: 100%;
            height: 88%;
            .echarts {
                width: 100%;
                height: 100%;
            }
        }
    }
}
</style>
